import { render, staticRenderFns } from "./EditMarqueeDialog.vue?vue&type=template&id=010beec3"
import script from "./EditMarqueeDialog.vue?vue&type=script&lang=js"
export * from "./EditMarqueeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports